import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import {
  listPublishedCategories,
  listPublishedProducts,
  getCategoryBySlug,
  getProductBySlug,
} from "./catalog.functions";
import type { Category, Product } from "./catalog.types";

export function useCategories() {
  const fn = useServerFn(listPublishedCategories);
  return useQuery({
    queryKey: ["categories", "published"],
    queryFn: () => fn({}) as Promise<Category[]>,
    staleTime: 60_000,
  });
}

export function useProducts() {
  const fn = useServerFn(listPublishedProducts);
  return useQuery({
    queryKey: ["products", "published"],
    queryFn: () => fn({}) as Promise<Product[]>,
    staleTime: 60_000,
  });
}

export function useCategory(slug: string) {
  const fn = useServerFn(getCategoryBySlug);
  return useQuery({
    queryKey: ["category", slug],
    queryFn: () => fn({ data: { slug } }) as Promise<{ category: Category; products: Product[] } | null>,
    staleTime: 60_000,
  });
}

export function useProduct(slug: string) {
  const fn = useServerFn(getProductBySlug);
  return useQuery({
    queryKey: ["product", slug],
    queryFn: () => fn({ data: { slug } }) as Promise<Product | null>,
    staleTime: 60_000,
  });
}

export function useCategoryLabel(slug: string | undefined) {
  const { data } = useCategories();
  if (!slug) return "";
  return data?.find((c) => c.slug === slug)?.name ?? slug;
}
